import { createFileRoute } from "@tanstack/react-router";
import { LoginPage } from "src/pages/login/LoginPage";

import { z } from "zod";
import { zodValidator } from "@tanstack/zod-adapter";

const loginSearchSchema = z.object({
  next: z.string().min(1).optional().catch(undefined),
});

export const Route = createFileRoute("/login")({
  component: LoginPage,
  validateSearch: zodValidator(loginSearchSchema),
});
